module.exports = __webpack_public_path__ + "static/media/Babys-dream-3.8ad20526.png";